import { baseApi } from '@/services'
import { Alerts, PaginatedResults } from '@/types/unlock'

export const alertsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listAlerts: builder.query<PaginatedResults<Alerts[]>, any>({
      query: ({ page, application_id, status }) => ({
        url: 'v2/alert/',
        params: {
          application__id: application_id,
          status,
          page_size: 200,
          page,
        },
      }),
      providesTags: ['Alert'],
    }),
    deleteAlert: builder.mutation<Alerts[], any>({
      query: ({ uuid, application_id }) => ({
        method: 'DELETE',
        url: `v2/alert/${uuid}/?application__id=${application_id}`,
      }),
      invalidatesTags: ['Alert'],
    }),
    updateAlert: builder.mutation<Alerts[], Partial<Alerts> | any>({
      query: ({ uuid, status, application_id }) => ({
        method: 'PATCH',
        url: `v2/alert/${uuid}/?application__id=${application_id}`,
        body: { status: status },
      }),
      invalidatesTags: ['Alert'],
    }),
    countAlerts: builder.query<number, number>({
      query: (application_id) => ({
        method: 'GET',
        url: `v2/alert/count-alerts/?application__id=${application_id}`,
      }),
      providesTags: ['Alert'],
    }),
    alertsTypes: builder.query<string[], number>({
      query: (application_id) => ({
        method: 'GET',
        url: `v2/alert/alerts-types/?application__id=${application_id}`,
      }),
      providesTags: ['Alert'],
    }),
  }),
})

export const {
  useListAlertsQuery,
  useDeleteAlertMutation,
  useUpdateAlertMutation,
  useCountAlertsQuery,
  useAlertsTypesQuery,
} = alertsApi
